module.exports = __webpack_public_path__ + "static/img/gongzhonghao.dcd1fae3.jpg";